(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const accordionAnimations = new WeakMap();
  const railAnimations = new WeakMap();
  function syncHeroVideos() {
    document.querySelectorAll('.idc-hero video').forEach(video => {
      if (reduced.matches || !video.offsetParent) video.pause();
      else video.play().catch(() => {});
    });
  }
  function init(root = document) {
    syncHeroVideos();
    const items = root.querySelectorAll('[data-idc-reveal]:not(.idc-observed)');
    if (reduced.matches || !('IntersectionObserver' in window)) {
      items.forEach(el => el.classList.add('idc-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('idc-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(el => { el.classList.add('idc-observed'); observer.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest('.idc-gallery__item');
    if (item) item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    const details = event.target.closest('.idc-faq details');
    if (details) details.open = true;
  });
  reduced.addEventListener('change', () => { syncHeroVideos(); init(); });
  window.addEventListener('resize', syncHeroVideos, { passive: true });
  document.addEventListener('click', event => {
    const summary = event.target.closest('.idc-faq summary');
    if (summary && !reduced.matches && Element.prototype.animate) {
      event.preventDefault();
      const details = summary.parentElement;
      const previous = accordionAnimations.get(details);
      const shouldOpen = previous ? !previous.opening : !details.open;
      const start = details.getBoundingClientRect().height;
      if (previous) previous.animation.cancel();
      details.open = true;
      const end = shouldOpen ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
      details.style.overflow = 'hidden';
      const animation = details.animate([{ height: `${start}px` }, { height: `${end}px` }], { duration: 350, easing: 'cubic-bezier(.25,1,.5,1)' });
      accordionAnimations.set(details, { animation, opening: shouldOpen });
      animation.onfinish = () => {
        details.open = shouldOpen;
        details.style.overflow = '';
        accordionAnimations.delete(details);
      };
      return;
    }
    const button = event.target.closest('[data-idc-gallery-step]');
    if (!button) return;
    const rail = button.closest('.idc-gallery').querySelector('[data-idc-gallery-rail]');
    const item = rail && rail.querySelector('.idc-gallery__item');
    if (!item) return;
    const distance = item.getBoundingClientRect().width + 14;
    const from = rail.scrollLeft;
    const to = Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, from + Number(button.dataset.idcGalleryStep) * distance));
    if (reduced.matches) { rail.scrollLeft = to; return; }
    const previous = railAnimations.get(rail);
    if (previous) cancelAnimationFrame(previous);
    const started = performance.now();
    rail.style.scrollSnapType = 'none';
    function tick(now) {
      const progress = Math.min(1, (now - started) / 600);
      const eased = .5 - Math.cos(progress * Math.PI) / 2;
      rail.scrollLeft = from + (to - from) * eased;
      if (progress < 1) railAnimations.set(rail, requestAnimationFrame(tick));
      else { rail.style.scrollSnapType = ''; railAnimations.delete(rail); }
    }
    railAnimations.set(rail, requestAnimationFrame(tick));
  });
})();
